import SecureUserStorage from "@gcloud-npm/utils.secure.user-secure-storage";

export async function setPurchaseInProgressInSecureUserStorage(
  purchaseInProgress,
  userId
) {
  const mySecureUserStorage = new SecureUserStorage();
  const secureInfoClient = await mySecureUserStorage.getUserStore({
    id: userId,
  });
  await mySecureUserStorage.setUserStore({
    id: userId,
    data: {
      ...(secureInfoClient || {}),
      purchaseInProgress,
    },
  });
}
